import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RewardsWalletService } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-marketplace-wallet-page',
  templateUrl: './marketplace-wallet-page.component.html',
  styleUrls: ['./marketplace-wallet-page.component.scss'],
})
export class MarketplaceWalletPageComponent implements OnInit {
  id: string;
  screenSize = ScreenType;

  constructor(
    private route: ActivatedRoute,
    private rewardsWalletService: RewardsWalletService
  ) {}

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') || '0';
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
  }
}
